import { DateTime } from 'luxon';

export const networkStatus = status => DateTime.local().diff(DateTime.fromISO(status.network)).as('minutes') < 5;
export const beaconStatus = status => DateTime.local().diff(DateTime.fromISO(status.beacon)).as('minutes') < 5;
export const cameraStatus = status => DateTime.local().diff(DateTime.fromISO(status.camera)).as('minutes') < 5;
